import React from 'react';
import {Button} from 'legacy_components/Button';
import {Modal} from 'legacy_components/Modal';
import styles from 'legacy_css_modules/Modal.module.css';

export const FvyModal = ({close, action}) => {
    return (
        <div className={styles.ontop}>
            <Modal name={"IČO klientské společnosti se shoduje s partnerem"} close={close}>
                
                <br></br>
                <div style={{padding:"1rem"}}>
                Chcete načíst odběratele z ISDOC jako partnera a změnit na fakturu vydanou?
                </div>
                <div className={styles.buttons}>
                    <Button onClick={close}>Zavřít</Button>
                    <Button primary onClick={action} type="submit">Zaměnit</Button>
                </div>
            </Modal>
        </div>
    )
};
